import React, { Component } from "react";
import { CommSubTabs } from "../CommSubTabs";
import ParentNotificationSection from "./CommParentNotificationSection";
import NotifyStudentSection from "./CommNotifyStudentSection";
import "../_communicationManagement.scss";

const SUB_TABS = [
  { key: "parent", label: "Parent Notifications", icon: "fal fa-user-friends" },
  { key: "student", label: "Student Notifications", icon: "fal fa-user-graduate" },
];

class MobileNotificationsTab extends Component {
  constructor(props) {
    super(props);
    this.state = { activeSubTab: "parent" };
  }

  handleSubTabClick = (key) => this.setState({ activeSubTab: key });

  renderSubContent = () => {
    switch (this.state.activeSubTab) {
      case "student":
        return <NotifyStudentSection />;
      case "parent":
      default:
        return <ParentNotificationSection />;
    }
  };

  render() {
    return (
      <div className="comm-mgmt">
        <CommSubTabs
          tabs={SUB_TABS}
          activeKey={this.state.activeSubTab}
          onSelect={this.handleSubTabClick}
        />
        {this.renderSubContent()}
      </div>
    );
  }
}

export default MobileNotificationsTab;
